import { ActionTree } from "vuex/types"
import { dataApi } from '@sitecore-jss/sitecore-jss-vue'

import get from '~/helpers/get'
import isEmptyObject from "~/helpers/is-empty-object"
import { RootState } from "~/store/store.types"

import { JssState } from "./types"
import { prependSlash } from "~/utils/url"
import { isSitecoreProxy } from "~/utils/environment"

const actions: ActionTree<JssState, RootState> = {
  async fetchRouteData ({ commit }, route) {
    const host = isSitecoreProxy(this.$env)
      ? 'http://localhost:3000/api/jss'
      : `${this.$env.SH_API_URL}/sitecore`
    const fetchOptions = {
      layoutServiceConfig: { host },
      querystringParams: { sc_lang: this.$i18n.locale },
      fetcher: (url: string, data?: object) => this.$axios({
        url,
        method: data ? 'POST' : 'GET',
        data,
        // headers
        // note: axios needs to use `withCredentials: true` in order
        // for Sitecore cookies to be included in CORS requests
        // which is necessary for analytics and such
        withCredentials: true
      })
    }

    try {
      const data = await dataApi.fetchRouteData(prependSlash(route.params.route), fetchOptions)

      if (isEmptyObject(data.sitecore.route)) {
        throw { response: { status: '404' } }
      }

      commit('setLayoutResponse', data)
    } catch (error) {
      commit('setLayoutError', get(error, 'response.status', '404'))
    }
  },

  enableIntegrationMode ({ commit }) {
    commit('setIntegrationMode', true)
  }
}

export default actions
